/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is GC content?`)
};

const es_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el contenido GC?`)
};

const de_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der GC-Gehalt?`)
};

const nl_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is GC-gehalte?`)
};

const fr_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le contenu GC ?`)
};

const it_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è il contenuto GC?`)
};

const pt_br2_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é conteúdo GC?`)
};

const pt_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é o conteúdo GC?`)
};

const ja_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC含量とは何ですか？`)
};

const zh_gc_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 GC 含量？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_faq_q1", locale)
	if (locale === "en") return en_gc_faq_q1(inputs)
	if (locale === "es") return es_gc_faq_q1(inputs)
	if (locale === "de") return de_gc_faq_q1(inputs)
	if (locale === "nl") return nl_gc_faq_q1(inputs)
	if (locale === "fr") return fr_gc_faq_q1(inputs)
	if (locale === "it") return it_gc_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_gc_faq_q1(inputs)
	if (locale === "pt") return pt_gc_faq_q1(inputs)
	if (locale === "ja") return ja_gc_faq_q1(inputs)
	return zh_gc_faq_q1(inputs)
};